import pacman1 from "../../../assets/images/background/pacman/1.png";
import pacman2 from "../../../assets/images/background/pacman/2.png";
import pacman3 from "../../../assets/images/background/pacman/3.png";
import pacman4 from "../../../assets/images/background/pacman/4.png";
import pacman5 from "../../../assets/images/background/pacman/5.png";
import pacman6 from "../../../assets/images/background/pacman/6.png";
import pacman7 from "../../../assets/images/background/pacman/7.png";
import pacman8 from "../../../assets/images/background/pacman/8.png";
import pacman9 from "../../../assets/images/background/pacman/9.png";
import pacman10 from "../../../assets/images/background/pacman/10.png";
import pacman11 from "../../../assets/images/background/pacman/11.png";

const pacman = {
	name: "Pacman",
	components: {
		pacman_1: {
			id: "pacman_1",
			image: pacman1,
			text: "Pacman tile 1",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		pacman_2: {
			id: "pacman_2",
			image: pacman2,
			text: "Pacman tile 2",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 0 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
			],
			waters: [],
		},
		pacman_3: {
			id: "pacman_3",
			image: pacman3,
			text: "Pacman tile 3",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		pacman_4: {
			id: "pacman_4",
			image: pacman4,
			text: "Pacman tile 4",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		pacman_5: {
			id: "pacman_5",
			image: pacman5,
			text: "Pacman tile 5",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 13, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 13, y2: 41 },
			],
			waters: [],
		},
		pacman_6: {
			id: "pacman_6",
			image: pacman6,
			text: "Pacman tile 6",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		pacman_7: {
			id: "pacman_7",
			image: pacman7,
			text: "Pacman tile 7",
			pois: { name: "", items: [] },
			walls: [],
			waters: [],
		},
		pacman_8: {
			id: "pacman_8",
			image: pacman8,
			text: "Pacman tile 8",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		pacman_9: {
			id: "pacman_9",
			image: pacman9,
			text: "Pacman tile 9",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		pacman_10: {
			id: "pacman_10",
			image: pacman10,
			text: "Pacman tile 10",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
				{ x1: 0, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
			],
			waters: [],
		},
		pacman_11: {
			id: "pacman_11",
			image: pacman11,
			text: "Pacman tile 11",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 11 },
				{ x1: 41, y1: 11, x2: 59, y2: 11 },
				{ x1: 59, y1: 11, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
	},
};

export default pacman;
